import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProjetoMoeda } from '../../../models/projeto-moeda.model';
import { ProjetoMoedaService } from '../../../services/projeto-moeda.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-projeto-moeda-list',
  templateUrl: './projeto-moeda-list.component.html',
  styleUrls: ['./projeto-moeda-list.component.scss'],
})
export class ProjetoMoedaListComponent
  extends BaseListComponent<ProjetoMoeda>
  implements OnInit, OnDestroy
{
  moedaList: ProjetoMoeda[];

  constructor(
    private myService: ProjetoMoedaService,
    public activatedRoute: ActivatedRoute
  ) {
    super();
  }

  ngOnInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.moedaList = res;
        this.loaded();
      })
    );
  }

  novo() {
    return ['/pre-projeto/admin/projeto-moeda/adicionar'];
  }

  editar(id: number) {
    return ['/pre-projeto/admin/projeto-moeda/', id];
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }
}
